"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaKekkaSokatsu = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 総括
 */
const KansaKekkaSokatsu = props => {
  const {
    intl,
    sokatsu,
    onChange,
    error,
    helperText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_SOKATSU
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: sokatsu,
    onChange: onChange,
    multiline: true,
    rows: 5,
    maxLength: 500,
    error: !!error,
    helperText: helperText
  }));
};
exports.KansaKekkaSokatsu = KansaKekkaSokatsu;
var _default = exports.default = (0, _reactIntl.injectIntl)(KansaKekkaSokatsu);